import React from 'react';
import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';

interface BaseCellWrapperProps {
  dataTestId: string;
  children: React.ReactNode;
}

export const BaseCellWrapper: React.FC<BaseCellWrapperProps> = React.memo(
  ({ dataTestId, children }) => {
    return (
      <FlexSpacer gap="threeQuarter" alignItems="center" data-test={dataTestId}>
        {children}
      </FlexSpacer>
    );
  },
);
